import { render, staticRenderFns } from "./WithholdingCard.vue?vue&type=template&id=59250b9b&scoped=true"
import script from "./WithholdingCard.vue?vue&type=script&lang=js"
export * from "./WithholdingCard.vue?vue&type=script&lang=js"
import style0 from "./WithholdingCard.vue?vue&type=style&index=0&id=59250b9b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59250b9b",
  null
  
)

export default component.exports